export default __webpack_public_path__ + "static/media/rejected.4fbf3561.svg";